<button
  type="button"
  class="settings"
  (click)="setTooltip(!tooltip)"
  [disabled]="isOffline || isZoomed"
  [class.cursorDefault]="isOffline || isZoomed"
>
  <txtb-icons
    [type]="iconType"
    [fill]="isOffline || isZoomed ? disabledColor : tooltip ? activeColor : null"
  ></txtb-icons>
</button>

<section class="tooltip" *ngIf="tooltip && !isOffline && !isZoomed">
  <ul class="colors">
    <li class="color input">
      <input
        #colorInput
        aria-label="color picker"
        type="color"
        class="color-input"
        [value]="color$ | async"
        (input)="emitColorChange($event)"
      />
      <txtb-icons
        type="colorPicker"
        class="color-picker"
        (click)="clickColorInput()"
        (touchend)="clickColorInput()"
      ></txtb-icons>
    </li>
    <li
      *ngFor="let color of colors"
      class="color {{ color.name }}"
      (click)="sendColor(color.value)"
      [class.active]="(color$ | async) === color.value"
      [style.background-color]="color.value"
    ></li>
  </ul>
  <form class="thickness" [formGroup]="thicknessForm">
    <label *ngFor="let item of thickness">
      <input
        type="radio"
        [id]="item.iconName"
        name="thickness"
        [value]="item.value"
        formControlName="thickness"
      />
      <txtb-icons [type]="$any(item.iconName)"></txtb-icons>
    </label>
  </form>
  <form class="transparency">
    <label *ngFor="let item of transparency" [formGroup]="transparencyForm">
      <input
        type="radio"
        [id]="item.iconName"
        name="transparency"
        [value]="item.value"
        formControlName="transparency"
      />
      <txtb-icons [type]="$any(item.iconName)"></txtb-icons>
    </label>
  </form>
</section>
